import React from 'react';
import { Stack } from '@mui/material';
import MaterialTypography from '../../../../components/MaterialTypography';
import MaterialInput from '../../../../components/MaterialInput';
import MaterialButton from '../../../../components/MaterialButton';
import MaterialBox from '../../../../components/MaterialBox';

const ScopeOfTesting = ({ formData, handleChange, handleAddScopePoint }) => {
    return (
        <Stack spacing={3}>
            <MaterialTypography variant="caption" fontWeight="bold">Scope of Testing</MaterialTypography>
            <Stack direction="row" spacing={2} alignItems="center">
                <MaterialInput
                    name="scopeText"
                    value={formData.scopeText}
                    onChange={handleChange}
                    placeholder="Enter scope detail"
                    fullWidth
                />
                <MaterialButton variant="gradient" color="info" onClick={handleAddScopePoint}>
                    Add
                </MaterialButton>
            </Stack>
            <Stack spacing={1} mt={2}>
                {formData.scopePoints.map((point, index) => (
                    <MaterialBox key={index} display="flex" alignItems="center">
                        <MaterialTypography variant="body2" color="text">
                            {index + 1}. {point}
                        </MaterialTypography>
                    </MaterialBox>
                ))}
            </Stack>
        </Stack>
    );
};

export default ScopeOfTesting;
